<modal-component class="_wide">

	<!-- LEFT-->
	<div class="_header" left>
		<!-- LEFT Create device -->
		<p *ngIf="action === Action.CREATE" class="_title" [translate]="'DEVICE.CREATE'"></p>
		
		<!-- LEFT Update device-->
		<ng-container *ngIf="action === Action.UPDATE">
			<p class="_title">
				{{device?.DeviceType.name}}
			</p>
		</ng-container>
		
		<p class="_subtitle">{{deviceForm?.get('serial').value}}</p>

		<ng-container *ifUserHasPermissions="[UserPermissions.ReadLoans]">
			<!-- HISTORY (show if device has history OR is in loan) -->
			<ng-container *ngIf="deviceHistory?.length > 0 || device?.Loans?.length > 0 ; else nohistory" >
				<div class="_device-history _info">
					<p class="_subtitle">{{'DEVICE.HISTORY' | translate }}:</p>

					<div *ngIf="device?.Loans[0]" class="_loan-container _active" (click)="openLoan(device?.Loans[0])">
						<p><b>{{'DEVICE.CURRENT_LOAN' | translate }}</b></p>
						<p class="_loan-date"><b>{{'LOAN.HISTORY_STARTS_AT' | translate}}: </b>{{device?.Loans[0].startsAt | date:"EEEE d MMM yyyy"}}</p>	
						<p class="_loan-date"><b>{{'LOAN.ENDS_AT' | translate}}: </b>{{device?.Loans[0].endsAt | date:"EEEE d MMM yyyy"}}</p>		
						<ng-container *ngIf="device?.Loans?.[0]?.Client">
							<p class="_client"><b>{{'LOAN.LOANED_TO_CLIENT' | translate}}: </b>{{device?.Loans[0].Client.firstname}} {{device?.Loans[0].Client.lastname}}</p>
						</ng-container>	
						<ng-container *ngIf="device?.Loans?.[0]?.DigibankAgencyOnLoan">
							<p class="_client">
								<b>{{'LOAN.LOANED_TO_PARTNER' | translate}}: </b>
								{{device?.Loans[0].DigibankAgencyOnLoan.DigibankAgency.name}} - {{device?.Loans[0].DigibankAgencyOnLoan.contactName}} - {{device?.Loans[0].DigibankAgencyOnLoan.contactEmail}}
							</p>
						</ng-container>					
								
					</div>

					<ng-container  *ngFor="let loan of device.History" >
						<div class="_loan-container" *ngIf="!loan.isActive"(click)="openLoan(loan)">
							<p class="_loan-date"><b>{{'LOAN.HISTORY_STARTS_AT' | translate}}: </b>{{loan.startsAt | date:"EEEE d MMM yyyy"}}</p>	
							<p class="_loan-date"><b>{{'LOAN.ENDS_AT' | translate}}: </b>{{loan.endsAt | date:"EEEE d MMM yyyy"}}</p>						
							<ng-container *ngIf="loan?.Client">
								<p class="_client"><b>{{'LOAN.LOANED_TO_CLIENT' | translate}}: </b>{{loan.Client.firstname}} {{loan.Client.lastname}}</p>
							</ng-container>	
							<ng-container *ngIf="loan?.DigibankAgencyOnLoan">
								<p class="_client">
									<b>{{'LOAN.LOANED_TO_PARTNER' | translate}}: </b>{{loan.DigibankAgencyOnLoan.DigibankAgency.name}} - {{loan.DigibankAgencyOnLoan.contactName}} - {{loan.DigibankAgencyOnLoan.contactEmail}}</p>
							</ng-container>		
						</div>
					</ng-container>
				</div>
			</ng-container> 
			<ng-template #nohistory >
				<div  *ngIf="device" class="_device-history _info">
					{{'DEVICE.HISTORY_EMPTY' | translate}}
				</div>
			</ng-template>	
		</ng-container>

	</div>
	
	<!-- RIGHT -->
	
	<!-- RIGHT: CREATE OR EDIT when device is not-in-loan AND is-active OR creating a new device -->
	<ng-container right>
		<p class="_title">{{'DEVICE.DETAILS' | translate}}</p>
		<form [formGroup]="deviceForm" *ngIf="deviceForm" >

			<!-- STATUS -->
			<ng-container *ngIf="action !== Action.CREATE">
				<form-select 
					[ngClass]="{'_disabled': device?.Loans[0]}" label="{{ 'DEVICE.STATUS' | translate }}" [formControl]="deviceForm.get('status') | cast" [items]="deviceStatus" bindValue="value" bindLabel="label" [multiple]="false">
				</form-select>
			</ng-container>

			<!-- DEVICE DETAILS -->
			<form-select label="{{ 'DEVICE.TYPE' | translate }}" [formControl]="deviceForm.get('DeviceTypeId') | cast" [items]="deviceTypes" bindValue="id" bindLabel="name" [multiple]="false">
				<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]" add-button>
					<button class="_button _add-button" (click)="createDeviceType()">
						<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
					</button>	
				</ng-container>
			</form-select>
			<form-input label="{{ 'DEVICE.SERIAL' | translate }}" [formControl]="deviceForm.get('serial') | cast"></form-input>
			<form-textarea label="{{ 'DEVICE.DESCRIPTION' | translate }}" [formControl]="deviceForm.get('description') | cast"></form-textarea>
			<form-textarea label="{{ 'DEVICE.NOTE' | translate }}" [formControl]="deviceForm.get('note') | cast"></form-textarea>
		</form>
	</ng-container>
	
	<!-- BUTTONS Save or create the device -->
	<ng-container buttons *ifUserHasPermissions="[UserPermissions.WriteDevices]">
		<button class="_button _save-button" [translate]="action === Action.CREATE ? 'DEVICE.CREATE' : 'DEVICE.UPDATE'" (click)="createOrUpdateDevice()"></button>
	</ng-container>


	<!-- DELETE DEVICE -->
	<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]" buttons>
		<button *ngIf="device?.status === DeviceStatus.Disabled" type="button" class="_button _delete-button" [translate]="'DEVICE.DELETE'" (click)="deleteDevice()"></button>
	</ng-container>


</modal-component>
